import { gql } from 'apollo-boost';

export const dialogsQuery = gql`
    query DialogsQuery($login: String!) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            dialogs {
                id
                name
                isActive
                skillId
            }
            chiefLogin
        }
    }
`;
